module.exports = __webpack_public_path__ + "media/images/flags/4x3/vir-3a2cefa979e6007642c8f2ae84fcb6e3.svg";